<!-- 表2填写 -->

<template>
  <div class="tabCage table8E">
    <div class="tabTtl">
      <span>表 1-8：人员基本情况登记表</span>
    </div>
    <div class="editArea">
      <el-form ref="paramCk" :model="params" :rules="rules">
        <table>
          <tr>
            <td class="edName">岗位类别：</td>
            <td class="radioText">
              <el-radio-group v-model="params.type" disabled>
                <el-radio :label="1">主要负责人</el-radio>
                <el-radio :label="2">其他负责人</el-radio>
                <el-radio :label="3">编辑人员</el-radio>
              </el-radio-group>
            </td>
          </tr>
          <tr>
            <td class="edName">姓名：</td>
            <td class="edInp">
              <el-input v-model="params.fullName" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">性别：</td>
            <td class="radioText">
              <el-radio-group v-model="params.gender" disabled>
                <el-radio v-for="item in dicDats['C017']" :label="item.code" :key="item.code">{{
                                             item.name }}</el-radio>
              </el-radio-group>
            </td>
          </tr>
          <tr>
            <td class="edName">身份证号（军官证号）：</td>
            <td class="edInp">
              <el-input v-model="params.idNumber" disabled size="small"></el-input>
            </td>
          </tr>
          <tr v-if="params.type!=3">
            <td class="edName">职务：</td>
            <td class="edInp">
              <el-form-item prop="job" :inline-message="true">
                <el-select v-model="params.job" size="small" disabled placeholder="请选择文化程度">
                  <el-option v-for="item in dicDats['C022']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">政治面貌：</td>
            <td class="edInp">
              <el-select v-model="params.politicalStatus" disabled size="small" placeholder="请选择">
                <el-option v-for="item in dicDats['C006']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="edName">文化程度：</td>
            <td class="edInp">
              <el-select v-model="params.culture" disabled size="small" placeholder="请选择">
                <el-option v-for="item in dicDats['C005']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="edName">手机号：</td>
            <td class="edInp">
              <el-input v-model="params.cellphone" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">专业：</td>
            <td class="edInp">
              <el-input v-model="params.major" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">职称系列：</td>
            <td class="edInp">
              <el-select v-model="params.professionalTitleSeries" disabled size="small" placeholder="请选择">
                <el-option v-for="item in dicDats['C007']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="edName">职称级别：</td>
            <td class="edInp">
              <el-select v-model="params.titleLevel" disabled size="small" placeholder="请选择">
                <el-option v-for="item in dicDats['C008']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="edName">持有出版专业职业资格证书情况：</td>
            <td class="edInp">
              <el-select v-model="params.certificateSituation" disabled size="small" placeholder="请选择">
                <el-option v-for="item in dicDats['C009']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </td>
          </tr>
          
          <tr>
            <td class="edName">入职时间：</td>
            <td class="edInp areaTime">
              <el-date-picker disabled v-model="params.rzDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
              </el-date-picker>
            </td>
          </tr>
          <tr>
            <td class="edName">离职时间：</td>
            <td class="edInp areaTime">
              <el-date-picker disabled v-model="params.lzDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
              </el-date-picker>
              <div class="tips">在职不填写</div>
            </td>
          </tr>
          <tr v-if="params.professionalCertificateId && params.certificateSituation!='ff8080816892204e0168fe6728c70902'">
            <td class="edName">出版专业职业资格证书：</td>
            <td class="edInp">
              <!-- <Upbtn :ableSure="urls1" @upFileId="fileTdSet1" />
                                        <div class="tips">注：上传文件格式为JPGE/PNG，文件大小不超过10M</div> -->
              <!-- <div class="imgfram">
                                      <img width="230" @click="goVSee(1)" :src="urls1" alt="">
                                  </div> -->
              <!-- <Upbtn class="upBtn" :ableSure="params.professionalCertificateId" viewType="2" /> -->
              
              <Upbtn class="upBtn" :ableSure="params.professionalCertificateId" @upFileId="fileTdSet1" 
                  viewType="2"
                  />              
            </td>
          </tr>
          <tr v-if="params.type != 3">
            <td class="edName">是否持有岗位培训合格证书：</td>
            <td class="edInp">
              <el-select v-model="params.isTrainCertificate" disabled size="small" placeholder="请选择">
                <el-option v-for="item in dicDats['C018']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr v-if="params.trainCertificateId && params.type != 3">
            <td class="edName">取得岗位证书时间：</td>
            <td class="edInp areaTime">
              <el-date-picker disabled v-model="params.trainCertificateDate" type="date" placeholder="选择日期" 
                :class="highLight == true ? 'highLight' : ''" value-format="yyyy-MM-dd">
              </el-date-picker>
              <div class="tips">岗位类别为主要负责人和其他负责人时需填写</div>
            </td>
          </tr>
          <tr v-if="params.trainCertificateId && params.type != 3">
            <td class="edName">岗位培训合格证书：</td>
            <td class="edInp">
              <!-- <Upbtn :ableSure="urls2" @upFileId="fileTdSet2"  />
                                          <div class="tips">注：上传文件格式为JPGE/PNG，文件大小不超过10M</div> -->
              <!-- <div class="imgfram">
                                        <img @click="goVSee(2)" :src="urls2" alt="">
                                   </div> -->

              <!-- <Upbtn class="upBtn" :ableSure="params.trainCertificateId" viewType="2" /> -->
                  <!-- :btnProps="{colId:'xkzFileId5'}" -->
              <Upbtn class="upBtn" :ableSure="params.trainCertificateId" @upFileId="fileTdSet1" 
                  viewType="2"
                  />
              
            </td>
          </tr>
        </table>
      </el-form>
    </div>


    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
    </div>

  </div>
</template>

<script>
  import {
    bsParams,
    paramsRule
  } from '@/components/LongParams/paramsEt8';
  import {
    tabUpdate8,
    tabRead8
  } from '@/api/pressRole/pressRole';
  import {
    detFile
  } from '@/api/account';
  import {
    getFileToken
  } from '@/api/account';
  // import Upbtn from '@/views/components/uploadCards';
  import Upbtn from "@/views/components/upload/uploadSingleView"
import { getPfileUrl } from '@/api/pressRole/pressRole';
  export default {
    components: {
      Upbtn
    },
    data() {
      return {
        dialogVisible: false,
        params: {},
        rules: paramsRule,
        submiting: false,
        dicDats: {},

        diaImg: '',

        urls1: '',
        urls2: '',

        highLight: false,

        img1:"",
        dialogVisible:false,
        img2:"",
        dialogImageUrl:"",
      }
    },
    methods: {      
      handlePictureCardPreview(file) {
          this.dialogImageUrl = file.url;
          this.dialogVisible = true;
      },
      getImageUrl:function(dat,col){
        let vm = this;
        // let url = "";
        getPfileUrl({id: dat}).then(response => {
          let url = response.payload.url
          // console.log('url=',url)
          vm[col] = url;
        })
        // return url;
      },
      dictInit: function () {
        let nameArr = ['C017', 'C018', 'C006', 'C005', 'C007', 'C008', 'C009'];
        let newPromise = this.$store.dispatch('dictUpdate', {
          codeArr: nameArr,
          type: 'arr'
        });
        newPromise.then(result => {
          this.dicDats = result;
        })

      },

      menReEdit: function () {
        let vm = this;
        tabRead8({
          id: this.$route.query.id
        }).then(response => {
          this.params = response.pworker;
          getPfileUrl({id: this.params.professionalCertificateId}).then(response => {
            this.img1 = response.payload.url     
            // console.log('img1=',this.img1)       
          })
          getPfileUrl({id: this.params.trainCertificateId}).then(response => {
            this.img2 = response.payload.url     
            // console.log('img2=',this.img2)       
          })
          
          // 选择时间距今如果超过5年，则高亮显示已过期
          if(this.params.trainCertificateDate){
            let trainCertificateDate = new Date(this.params.trainCertificateDate.replace(/-/g, '/'));
            let timeDifference = 0;
            if(trainCertificateDate && trainCertificateDate!='Invalid Date'){
              timeDifference = new Date().getTime() - trainCertificateDate.getTime();
            }
            // console.log('1=',24 * 60 * 60 * 1000 * 1820)
            // console.log('1=',timeDifference)
            if (timeDifference >= 24 * 60 * 60 * 1000 * 1820) {
              // console.log('true');
              this.highLight = true;
            } else {
              // console.log('false');
              this.highLight = false;
            }
          }

          // getFileToken().then(inresp => {
          //      if (vm.params.professionalCertificateId) {
          //           vm.urls1 = process.env.BASE_API + '/File/File/download/token/' + inresp.resultStatus.token + '/id/' + vm.params.professionalCertificateId;
          //      }

          //      if (vm.params.trainCertificateId) {
          //           vm.urls2 = process.env.BASE_API + '/File/File/download/token/' + inresp.resultStatus.token + '/id/' + vm.params.trainCertificateId;
          //      }
          // })

        })
      },

      fileTdSet1: function (dat) {
        this.params.professionalCertificateId = dat;
      },

      fileTdSet2: function (dat) {
        this.params.trainCertificateId = dat;
      },

      goVSee: function (code) {
        if (code == 1) {
          this.diaImg = this.urls1;
        } else if (code == 2) {
          this.diaImg = this.urls2;
        }

        this.dialogVisible = true;
      },

      colseHandle: function () {
        this.diaImg = '';
        return true;
      },

      goBack: function () {
        this.$router.go(-1);
      }
    },
    created: function () {
      this.dictInit();
      this.menReEdit();
    }
  }
</script>

<style lang="scss">
  @import "src/styles/pressRoleE";

  .highLight{
    .el-input__inner,.el-textarea__inner{
      color: red!important;
    }
  }
  .table8E .radioText {
    padding-left: 15px;
    padding-bottom: 13px;
  }

  .table8E {
    .imgfram {
      height: 120px;
    }

    .imgfram img {
      height: 120px;
      margin-bottom: 12px;
      cursor: pointer;
    }
  }

  .table8E .radioText .el-radio__label {
    margin-left: -5px;
  }

  .table8E .edName {
    width: 240px !important;
  }

  
  .addHide .el-upload--picture-card{
    display: none;
  }

  .addHide .el-upload-list .el-upload-list__item{
    margin: 0 8px 0 0;
  }
</style>



// WEBPACK FOOTER //
// table8.vue?583aea6b